import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from 'react-router-dom';
import {
    AiFillGithub,
    AiOutlineTwitter,
    AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { CiLocationOn } from "react-icons/ci";


import logoWhite from "../Assets/logo-white.png";

function Footer() {
    let date = new Date();
    let year = date.getFullYear();
    return (
        <section className="bg-theme text-white">
            <Container className="py-5">
                <Row>
                    <Col md={12} className="bg-footer-dark p-5 border-0 dark-logo-bg">
                        <h2 className="heading-style-h2">How It All Fits Together</h2>
                        <p>
                            A structured approach that keeps delivery predictable and systems
                            reliable over time.
                        </p>
                        <Link to="/about" className="mt-3 btn btn-outline-light ls-10 rounded-pill text-uppercase">
                            LEARN MORE
                        </Link>
                    </Col>
                </Row>
            </Container>

            {/* Main Footer */}
            <Container className="footer-main pb-5">
                <Row>

                    {/* Left */}
                    <Col md={4} className="pb-4 pb-md-0">
                        <Image src={logoWhite} className="w-50" />
                        <p className="dark-text">Get Parabola at your organisation.</p>
                        <div className="d-flex">
                            <CiLocationOn size={30} />
                            <div className="ps-2">
                                <p>Visakhapatnam</p>
                                <small>Plot No. 100, Sector 1, MVP Colony, Andhra Pradesh, India, 530017</small>
                            </div>
                        </div>


                    </Col>

                    {/* What We Do */}
                    <Col md={3} className="pb-4 pb-md-0">
                        <h6>What We do</h6>
                        <ul className="list-unstyled lh-lg">
                            <li><Link to="/custom_software">Custom Software Development</Link></li>
                            <li><Link to="/mobile_application">Mobile Application Development</Link></li>
                            <li><Link to="/devops_cloud">DevOps & Cloud Solutions</Link></li>
                            <li><Link to="/qa_testing">QA & Testing</Link></li>
                            <li><Link to="/offshore_team">Offshore Team Setup</Link></li>
                        </ul>
                    </Col>

                    {/* Industries */}
                    <Col md={3} className="pb-4 pb-md-0">
                        <h6>Industries</h6>
                        <ul className="list-unstyled lh-lg">
                            <li>Healthcare</li>
                            <li>E-commerce</li>
                            <li>SaaS & Technology</li>
                            <li>Logistics</li>
                            <li>Education</li>
                        </ul>
                    </Col>

                    {/* Quick Links */}
                    <Col md={2}>
                        <h6>Quick Links</h6>
                        <ul className="list-unstyled lh-lg">
                            <li><Link to="/about">About us</Link></li>
                            <li>Our Team</li>
                            <li>Blogs</li>
                            <li>Careers</li>
                        </ul>
                    </Col>

                </Row>
            </Container>

            {/* Bottom Bar */}
            <div className="bg-gradient-3 py-3">
                <Container className="d-md-flex justify-content-between align-items-center text-white">
                    <p className="mb-0">Copyright © {year} Parabola</p>

                    <ul className="footer-icons">
                        <li className="social-icons">
                            <a
                                href="#"
                                style={{ color: "white" }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <AiFillGithub />
                            </a>
                        </li>
                        <li className="social-icons">
                            <a
                                href="#"
                                style={{ color: "white" }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <AiOutlineTwitter />
                            </a>
                        </li>
                        <li className="social-icons">
                            <a
                                href="#/"
                                style={{ color: "white" }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaLinkedinIn />
                            </a>
                        </li>
                        <li className="social-icons">
                            <a
                                href="#"
                                style={{ color: "white" }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <AiFillInstagram />
                            </a>
                        </li>
                    </ul>
                </Container>
            </div>
        </section>

    );
}

export default Footer;